import { SuperFundModel } from "./superfund.model";

export class RollinModel {
    superFundList: SuperFundModel[] = [];
    rolloverAgreement:boolean = false;
}
